// @flow

// Libs
import { createSelector } from 'reselect'
import _find from 'lodash/find'

// Utils
import traverse from 'fc-utils/traverse'

// Selectors
import { fields$ } from 'fc-assets'

// Types
import type { AssetsById } from 'fc-model-assets/types'

// Constants
import { PROP_ASSET_ID } from 'fc-model-assets'

// Local Selectors
export const selectedFieldIdNotValidated$ = traverse(['mapModule', 'selectedFieldId', Number])

// Exports
export default createSelector([fields$, selectedFieldIdNotValidated$],
  (fields: AssetsById, fieldId: number): ?number => {
    const isValidFieldId = _find(fields, { [PROP_ASSET_ID]: fieldId })

    return isValidFieldId ? fieldId : null
  }
)
